import { Box, IconButton, styled } from '@mui/material';

export const MobileHeaderBar = styled('header')(({ theme }) => ({
  margin: theme.spacing(-1.5),
  padding: theme.spacing(1.5),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const MobileHeaderTitleArea = styled(Box)({
  minWidth: 0,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

export const MobileHeaderTrailing = styled(Box)({
  flex: 1,
  textAlign: 'right',
});

export const MobileHeaderContent = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1.25),
}));

export const MobileHeaderBackButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const MobileHeaderForwardButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.primary,
}));
